/**
 * 命名格式：platform.业务场景描述(xx_yy_zz).[唯一标识xxx].[唯一标识yyy]
 */

export const LOCAL_STORAGE = {
    LANG: 'fx.lang', // 语言
    SIGN_IN: {
        PHONE_AREA: 'jdy.signin.phone.area' // 手机区号
    },
    SUITE_ACCESS_TOKEN: 'platform.suite_access_token'
};

export const LOCAL_STORAGE_MIGRATE = {
    SIGN_IN_PHONE_AREA: 'jdy.signin_phone_area' // 手机区号
};
